<template>
  <div id="app" :class="app_classes">    

    <div class="banner_ps" v-if="this.$store.state.ps">
      27 IARC Participating States
    </div>

    <LayoutIarc
      v-if="is_factsheet==false"
      v-bind:website_title="'Cancer TODAY'"
      v-bind:website_url="this.$store.state.env.BASE_URL"
      v-bind:website_logo="logo"
      v-bind:website_mobile_logo="logoMobile"
      v-bind:website_menu="[
        { label : 'Home' , path : '/today' , route : 'home' , class : 'current' , is_home : true } , 
        { label : 'About' , path : '/today/about' , route : 'about' } , 
        { label : 'Data & methods' , path : '/today/data-sources-methods' , route : 'data-sources-methods' , 
          submenu : [
            { label : 'Incidence' , hash : '#incidence' } , 
            { label : 'Mortality' , hash : '#mortality' } , 
            { label : 'Prevalence' , hash : '#prevalence' } , 
            { label : 'Cancer dictionary' , hash : '#cancer-dictionary' } , 
            { label : 'Population dictionary' , hash : '#population-dictionary' } , 
            { 
              label : 'Supplemented material including the list of cancer registries that contributed to the GLOBOCAN project' , 
              hash : '#' 
            } , 
            { 
              label : 'Cancer incidence and mortality data: sources and methods by country' , 
              hash : '#' 
            } 
          ] 
        } ,
        { label : 'Population factsheets' , path : '/today/population-factsheets'  , route : 'population-fact-sheets'} , 
        { label : 'Cancer factsheets' , path : '/today/population-factsheets'  , route : 'cancer-fact-sheets'} , 
        { label : 'Dataviz' , path : '/today/dataviz' , route : 'dataviz' } 
      ]"
    />
    <FactsheetLayout
      v-if="is_factsheet==true"
      />
  </div>
</template>

<script>
import TheLanguageSwitcher from '@/csu-vue-components/components/TheLanguageSwitcher'
import IarcFooter from '@/csu-vue-components/components/IarcFooter.vue'
import TheMobileNavigation from '@/csu-vue-components/components/TheMobileNavigation'
import TheNavigation from '@/csu-vue-components/components/TheNavigation'
import Mobile from '@/csu-vue-components/components/Mobile'
import Theming from '@/components/Theming'

import LayoutIarc from '@/csu-vue-components/themes/iarc_new/Layout.vue'
import FactsheetLayout from './views/Factsheet/FactsheetLayout.vue'
import Constant from './const.js' 

export default {
  name: 'app',
  components: {
    TheNavigation , 
    IarcFooter, 
    Mobile, 
    TheMobileNavigation , 
    Theming , 
    LayoutIarc , 
    FactsheetLayout
  },
  created(){
    this.$store.commit('setEnv',process.env) ; 
    window.addEventListener("resize", this.setGraphicSizes );
    this.handleResize();
  },
  destroyed() {
    window.removeEventListener('resize', this.handleResize);
  },
  mounted() {

    // console.info("this.$store.state.",this.$store.state.env) ; 

    this.findRoute();
    // $('head').append(`<link rel="stylesheet" type="text/css" href="${this.public_path}css/print.css" media="print">`) ; 

    this.logo = require(`@/assets/img/logos/CancerToday-logo-blue.png`) ; 
    this.logoMobile = require(`@/assets/img/logos/CancerToday-logo-with-text-white.png`) ; 

    if ( this.$store.state.ps ) 
    {
      
      this.app_classes.push('app_ps_27')
      
      // adjust main menu
      // console.log("website_menu",this.website_menu) ; 
    }
  },
  data: function(){
    return {
        data_version : Constant.data_version , 
        route : 'home' ,
        public_path : `/${Constant.publicPath}/`,
        class_app : '' , 
        window: {
            width: 0,
            height: 0
        },
        logo : '', 
        logoMobile : '' , 
        is_factsheet : false , 
        app_classes : []
    } 
  },
  methods : {

    /**
    * Find route
    */
    findRoute : function(){
      let uri     = window.location.pathname.split('/') ; 
      this.route = ( uri[uri.length-1].length > 2 ) ? uri[uri.length-1] : '' ;
      this.is_factsheet = ( uri.includes('fact-sheet-population') || uri.includes('fact-sheet-cancer') ) ; 

    },
    handleResize() {
      this.window.width = window.innerWidth;
      this.window.height = window.innerHeight;
      this.$store.commit('setWindow',this.window) ; 
    },
    /**
    * Control size of .graphic depending on #container-filters
    * @param(no param)
    */
    setGraphicSizes_ : function(){
      // to change in a longer term, specify container col-md-9 differently
      let window_width_container = $(window).width() ;
      //$('.page.dataviz .page_content .col-md-9').width() ; // $('.graphic').width() ; 

      // console.log("graphic_width_container",graphic_width_container) ; 
      let adaptive_w = window_width_container-(110+$('.filters').width()+45) ; // sub menu + filters 
      $('.graphic').css('width',adaptive_w) ; 

     
    }
  }, 
  watch:{ 
      $route : function(to){
        if ( to.name != "home") 
          this.route = to.name ; 
        else
          this.findRoute();
      }
  }
}
</script>

<style lang="scss">

$bg_color: #0b80b7 ; 
$blue: #2B3256 ; 

/* import common css app */
/* @import '@/csu-vue-components/assets/css/app.scss' ;*/

@import '@/csu-vue-components/themes/iarc_new/assets/css/slick-theme.css' ;

html{
  overflow-x: hidden ; 
}

body{

  #header-menu{
    box-shadow: 0 0 20px rgba(0, 0, 0, 0.2);
  }
  
  .app_ps_27{

    .banner_ps{
      position: fixed ; 
      background: #d27f64 ; 
      width: 100%;
      padding: 3px 0 0px ;
      top: 0 ; 
      font-size: 11px;
      color: #fff ; 
      text-align: center ; 
      z-index: 99;
      transition: all 0.2s ease-in-out;
    }

    select#version_switcher{
      display: none ; 
    }

    .header-menu-links{
      .menu-item{
        &:nth-child(3){ display: none; }
        &:nth-child(5){ display: none; }
      }
    }
  }

  &.body_scrolling{
    .banner_ps{
      top: -30px;
    }
  }

  .container-anchor{
    position: relative ;
    .anchor{
      position: absolute;
      top: -180px ;
    }
  }

  table{
    thead.table-versions{
      tr{
        th{
          font-size: 18px;
        }
      }
    }
  }

  .custom-home-page{
    h2{
      padding-top: 15px ; 
    }
  }

  #bar-container{
    min-height: 850px; 
    padding-bottom: 50px ;

    svg{
      display: block ; 
      margin:auto ;

      /*rect.bar,rect.bar_right,rect.swatch{
        stroke: #000;
        stroke-width:0.5px;
      }*/
      
      .tick{
        text{
          font-size: 1.4em;
        }
      }

      text.legend{
        font-size: 0.9em;
        font-weight: bolder;
      }

      text.bar_txt {
        font-size: 0.8em;
      }
    }
  }

  #bar-container.multiple_nb{
    svg .tick text{
      font-size: 1.1em!important;
    }
  }

  ul.sub-menu{
    li{
      a.globe_icon{
        padding: 6px ;
      }
    }
  }

  .view_label_position_left{
    svg{
      .axis_y2{
        .tick{
          display: none;
        }
      }
    }
  }

  .view_label_position_right,.view_label_position_middle{
    svg{
      .axis_y{
        .tick{
          display: none;
        }
      }
    }
  }

  .graphic{
    min-height: 800px;
    #copyright-container{
      height: 0 ; 
      #copyright{
        bottom: 5px;
        left: 10px;
        a{
          color: $blue ; 
        }
      }
      .copyright_txt{
        font-size: 11px;
      }
    }
    img.img_copyright{
      max-height: 60px; 
      right: 10px; 
      bottom: 10px ;
    }
  }

  .block, .download{
    height: auto ; 
  }


  .bars{
    label[for="input_view_all"]{
      display: none !important;
    }
    label[for="input_view_regions"],label[for="input_view_countries"]{
      width: 50%!important;
    }
    #bar-container[attr-nb-items="-1"][attr-mode="cancer"]{
      svg .tick text{
        font-size: 1em;
      }
      svg text.bar_txt{
        font-size: 0.6em;
      }
    }
  }

  .tabs_dataviz,.tab_factsheets{

    ul.nav.nav-tabs{
      
      li.nav-item{
        a.nav-link{
          padding: 10px 20px ;
        }
      }
    }

    .group_blocks{
      padding: 20px ;
      border: solid 1px #dee2e6;
      border-top: none ; 
      margin: 0 0px;
    }
  }

  form{
    fieldset.layout_6{
      width: 50%;
      min-height: 65px;
      .multiselect__input, .multiselect__single{
        width: 105%;
      }
    }
  }

}

@media (max-width: 575px){
  
  .tabs_dataviz,.tab_factsheets{
    
    .group_blocks{
      background: #fff ;
      .rect-photo-card .rect-photo-card-content {
          min-height: 350px;
      }
    }

    &.tab_populations_factsheets{
      .rect-photo-card .rect-photo-card-content {
        aspect-ratio: auto;
        a.doc-link{
          font-size: 13px !important;
        }
      }
    }
  }

}



@media (min-width: 992px){
  .full-width {
      padding: 0px 105px !important;
  }
}

</style>